<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-trade__currency}">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item label="货币名称：">
          <el-input v-model="dataForm.name" placeholder="" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()">{{ $t('query') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('trade:currency:save')" type="primary" @click="addOrUpdateHandle()">
            {{ $t('add') }}
          </el-button>
        </el-form-item>
      </el-form>
      <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle"
                style="width: 100%;">
        <el-table-column type="index" label="行号" header-align="center" align="center" width="50"></el-table-column>
        <el-table-column prop="name" label="货币名称" header-align="center" align="center"></el-table-column>
        <el-table-column prop="remark" label="备注" header-align="center" align="center"></el-table-column>
        <el-table-column prop="creatorName" label="创建者" header-align="center" align="center"></el-table-column>
        <el-table-column prop="createDate" label="创建时间" header-align="center" align="center"></el-table-column>
        <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <el-button v-if="$hasPermission('trade:currency:update')" type="text" size="small"
                       icon="el-icon-edit-outline"
                       @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}
            </el-button>
            <el-button v-if="$hasPermission('trade:currency:delete')" type="text" size="small"
                       icon="el-icon-close"
                       @click="deleteHandle(scope.row.id)">{{ $t('delete') }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          :current-page="page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="limit"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="pageSizeChangeHandle"
          @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './add-or-update'

export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/trade/currency/page',
        getDataListIsPage: true,
        exportURL: '/trade/currency/export',
        deleteURL: '/trade/currency',
        deleteIsBatch: true
      },
      dataForm: {
        name: ''
      }
    }
  },
  components: {
    AddOrUpdate
  }
}
</script>
